<template>
  <div class="digital-article-menu" :class="{ 'digital-article-menu-mobile': isMobile }" :style="{ width: width.toString().indexOf('%') === -1 ? width + 'px' : width }" v-if="show">
    <div class="top" v-if="width === 400">
      <div class="txt">{{ currentLang === 1 ? 'Contents' : '本期导读' }}</div>
      <div class="txt txt-right ">
        <span @click="changePublication('prev')">{{ currentLang === 1 ? 'Previous' : '上一期' }}</span>
        <span @click="changePublication('next')">{{ currentLang === 1 ? 'Next' : '下一期' }}</span>
      </div>
    </div>
    <div class="top" v-else>
      <div class="txt">{{ currentLang === 1 ? 'Contents' : '版面文章目录' }}</div>
      <div class="close" @click="close">
        <img src="@imgs/digital/close.png" v-if="!isMobile" />
        <img src="@imgs/digital/close-black.png" v-if="isMobile" />
      </div>
    </div>
    <div class="box" id="digital-article-menu-box" @touchstart="boxTouchstart" @touchmove="boxTouchmove">
      <div class="area" v-if="notRevokeArticles">
        <div class="item" v-for="(page, catalogIndex) in notRevokeArticles" v-bind:key="page.id" :class="{ selected: page.selected }">
          <div class="title">
            <div class="line"></div>
            <div class="text" :class="{ selected: page.page === pageIndex }" @click="changeArticle(page, page.children ? page.children[0] : page, catalogIndex + 1, page.xiaoYangId ? 2 : 1)">
              {{ page.label }}
            </div>
          </div>
          <div class="list">
            <div
              class="text"
              v-for="(article, index) in page.children"
              v-bind:key="index"
              :class="{ selected: article.xiaoYangId == articleIndex }"
              @click="changeArticle(page, article, article.page, 2)"
            >
              {{ article.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apis from '@api/getBook'
export default {
  name: 'DigitalArticleMenu',
  components: {},
  props: {
    width: {
      type: [Number, String],
      default: 300
    },
    articles: {
      type: Array,
      default: () => {
        return []
      }
    },
    initShow: {
      type: Boolean,
      default: false
    },
    initPageIndex: {
      type: Number,
      default: 1
    },
    initArticleIndex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      show: this.initShow,
      pageIndex: this.initPageIndex, // 页面当前索引（从1开始）
      articleIndex: this.initArticleIndex, // 文章当前小样id,
      box: null,
      boxY: 0,
      boxTouchY: 0
    }
  },
  watch: {
    initShow(show) {
      this.show = show
    },
    initPageIndex(pageIndex) {
      this.pageIndex = pageIndex
    },
    initArticleIndex(articleIndex) {
      this.articleIndex = articleIndex
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    paperId() {
      return this.$store.state.config.bookObj.id
    },
    notRevokeArticles() {
      return this.articles.filter((item) => !item.revokeStatus)
    },
    currentLang() {
      return this.$store.state.config.bookObj.language
    }
  },
  methods: {
    boxTouchstart(e) {
      this.box = document.getElementById('digital-article-menu-box')
      this.boxY = this.box.scrollTop
      this.boxTouchY = e.touches[0].pageY
    },
    boxTouchmove(e) {
      this.box.scrollTop = this.boxTouchY - e.touches[0].pageY + this.boxY
    },
    changeArticle(page, article, pageIndex, optype) {
      this.pageIndex = parseInt(pageIndex)
      this.articleIndex = article.xiaoYangId
      this.$emit('onChangeArticle', page, article, parseInt(pageIndex), optype)
    },
    close() {
      this.show = false
      this.$emit('onClose')
    },
    changePublication(type) {
      const params = {
        id: this.paperId,
        flag: type
      }
      apis.getRecentEpaper(params).then((res) => {
        let { data } = res.data
        if (data) {
          this.$router.push({
            path: this.$route.path,
            query: { ...this.$route.query, id: data.id }
          })
          location.reload()
        }
      })
    }
  }
}
</script>
<style lang="scss">
.digital-article-menu {
  position: absolute;
  left: 0;
  top: 0;
  width: 300px;
  height: 100%;
  background: #ffffff;
  z-index: 999;
  // &.static {
  //   position: static;
  //   margin-left: -5px;
  //   height: calc(100% + 80px);
  //   flex-shrink: 0;
  // }
  .top {
    position: relative;
    background: #df5813;
    .txt {
      display: block;
      width: 100%;
      line-height: 40px;
      text-align: center;
      color: #ffffff;
      font-weight: bold;
      font-size: 16px;
    }
    .close {
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 40px;
      text-align: center;
      cursor: pointer;
      img {
        margin-top: 13px;
        width: 14px;
        height: 14px;
      }
    }
  }
  .box {
    height: calc(100% - 40px);
    overflow: auto;
    .area {
      .item {
        font-size: 16px;
        padding-top: 10px;
        border-bottom: 5px solid #e3e3e3;
        background: #fff;
        &:last-child {
          border-bottom: none;
        }
        .title {
          position: relative;
          .line {
            position: absolute;
            background: red;
            left: 20px;
            top: 14px;
            width: 3px;
            height: 16px;
          }
          .text {
            font-weight: bold;
            line-height: 24px;
            padding: 10px 31px 10px 34px;
            cursor: pointer;
            &:hover {
              background: #f3f3f3;
            }
            &:active {
              background: #e3e3e3;
            }
          }
          .selected {
            background: #e3e3e3;
          }
        }
        .list {
          .text {
            line-height: 24px;
            padding: 10px 31px 10px 34px;
            border-bottom: 1px solid #f3f3f3;
            cursor: pointer;
            &:last-child {
              border-bottom: none;
            }
            &:hover {
              background: #f3f3f3;
            }
            &:active {
              background: #e3e3e3;
            }
          }
          .selected {
            background: #e3e3e3;
          }
        }
      }
    }
  }
}
.digital-article-menu-mobile {
  z-index: 9998;
  .top {
    background: #f5f5f5;
    .txt {
      color: #3a3a3a;
    }
  }
}
.paper-turn-digital-article-menu {
  width: 400px;
  background: #ffffff;
  height: 695px;
  display: inline-block;
  margin-right: 20px;
  flex-shrink: 0;
  position: relative;
  z-index: 5;
  .top {
    display: flex;
    justify-content: space-between;
    .txt {
      width: fit-content;
      margin-left: 10px;
    }
    .txt-right {
      font-weight: 400;
      span {
        margin-right: 10px;
      }
    }
  }
}
</style>
